import { GetUsers } from './getUsers'
import {DEFAULT_PAGE} from "../../contstants";

const FilterUsers = async (perPage,filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const status = filters.status || '';
    const role = filters.role || '';
    const searchPhrase = filters.s;
    const searchInFields = filters.search_in_fields || '';
    const email = searchInFields.includes('email') ? searchPhrase : '';
    let first_name = searchInFields.includes('first_name') ? searchPhrase : '';
    const last_name = searchInFields.includes('last_name') ? searchPhrase : '';
    const office = searchInFields.includes('office') ? searchPhrase : '';

    if(!email && !first_name && !last_name && !office && filters.s){
        first_name = searchPhrase;
    }

    return await GetUsers(perPage, (page - 1) * perPage, status, role, email, first_name, last_name, office);
};

export default FilterUsers;
